import _ from 'underscore';
import Radio from 'backbone.radio';
import strings_specific from 'amdi18n-loader!@/nls/dashboard';

    var strings = _.extend({}, strings_specific);

    var globalCh = Radio.channel('global');
    var routerCh = Radio.channel('router');

    function ensure_account_loaded(account) {
        var active_account = globalCh.request('active_account');

        if (!account || account.id === active_account.id) {
            return dashboard(active_account);
        }

        globalCh.request('changeActiveAccount', account, function() {
            dashboard(account);
            globalCh.request('home');
        });
    }

    function dashboard() {
        var active_account = globalCh.request('active_account');
        // var primary_account = globalCh.request('primary_account');

        // TODO: Products don't have dashboards yet
        globalCh.request('set_selection', {
            type: 'app',
            id: 'dashboard'
        });

        routerCh.request('set_location', 'dashboard', active_account);

        return globalCh.request('no_access', null, null,
            strings.go_to_ide);
    }

    export default ensure_account_loaded;

